import { DataPoint } from 'Interfaces/DataPoint';
import './Style.scss';
import * as React from 'react';
import { ListItem } from 'Interfaces/Forms/QuestionInterface';
import { Eye, File } from 'lucide-react';
import PulseDot from 'react-pulse-dot';
import 'react-pulse-dot/dist/index.css';
import FormUtils from 'views/SingleInstance/utils/FormUtils';
import { isNullOrUndefined } from 'utils/utils';
import { useAppDispatch, useAppSelector } from 'index';
import { SingleInstanceInterface } from 'Interfaces/ModuleSelectionInterface';
import { setSingleInstance } from 'actions/moduleSelectionActions';
import { getOptionTexts, isSelectQuestion } from 'views/SingleInstance/utils/utils';
import MoreTextComponent from 'views/Table/MoreTextComponent';
import { useDraggable } from '@dnd-kit/react';
import { uniqueFormsSelector } from 'reducers/formsReducer';
import { getLocalization } from 'global/global';

interface Props {
  dataPoint: DataPoint;
  status: ListItem;
  severityListItem: ListItem[];
  extraFields: string[];
  formUtils: FormUtils;
  showMultiViewer: (dp) => void;
}
export default function TaskCard(props: Props) {

  const dispatch = useAppDispatch();
  const forms = useAppSelector(state => uniqueFormsSelector(state));

  const { ref } = useDraggable({
    id: `${props.dataPoint.id}`,
    data: { status: `${props.dataPoint['kanbanStatus']}` }
  });

  const { dataPoint, severityListItem, extraFields, formUtils } = props;

  const [isDue, setIsDue] = React.useState<true | null | 'soon'>(null);
  const [severityColor, setSeverityColor] = React.useState('');

  React.useEffect(() => {
    if (dataPoint['kdueDate']) {
      const date = new Date(dataPoint['kdueDate']);
      const today = new Date();
      if (date.getTime() < today.getTime()) {
        setIsDue(true);
      }
    }
    const severity = dataPoint['kanbanPriority'] || dataPoint['ncrb_severity'];
    const listItem = severityListItem.find(li => li.id && li.id === severity);
    if (listItem) {
      setSeverityColor(listItem.color || '');
    }
  }, [dataPoint, severityListItem]);

  const openSingleInstance = () => {
    const singleInstance: SingleInstanceInterface = {
      model: formUtils.getModel(),
      dataPoint,
      newAnswer: false,
    };
    dispatch(setSingleInstance(singleInstance));
  };

  const getQuestionText = (id) => {
    switch (id) {
      case 'questionnaire_id':
        return getLocalization('templateName');
      default:
        return '';
    }
  };

  return (
    <div
      ref={ref}
      className="task-card p-3 mb-3 shadow-sm pointer"
      data-testid={'task-card'}
      style={severityColor ? { borderLeft: '10px', borderColor: severityColor, borderLeftStyle: 'solid'} : undefined}
    >
      <div className="d-flex mb-2">
        <h4
          className="me-auto header mb-0"
          data-testid={'name-header'}
          onClick={openSingleInstance}
        >{dataPoint['Name']}</h4>
        {isDue && <PulseDot color={isDue === true ? 'danger' : 'warning'} data-testid="due-date-pulse" />}
        {<Eye onClick={() => props.showMultiViewer(dataPoint)}/>}
        {/* <span
          className="status-text px-2"
          style={{ backgroundColor: status.color, color: status.color ? 'white' : undefined }}
        >{status.value}</span>*/ }
      </div>
      {extraFields.map((ef) => {
        if (!isNullOrUndefined(dataPoint[ef])) {
          let value = dataPoint[ef];
          const qn = formUtils.getQuestion(ef);
          if (qn && isSelectQuestion(qn.type) && value) {
            value = getOptionTexts(qn, `${value}`.trim().split(','));
          }
          if (ef === 'questionnaire_id' && value) {
            const form = forms.find(f => f.ref === value);
            value = form?.name;
          }
          const text = qn ? qn.text : getQuestionText(ef);
          return (
            <div className="mt-2" key={`${dataPoint['id']}-${ef}`}>
              <label>{text}</label>
              {value.length > 100 ? (
                <p className="mb-3 body-text">
                  {value.substring(0, 100)}
                  <MoreTextComponent question={qn} value={value} />
                </p>
              ) : <p className="mb-3 body-text">{value}</p>}
            </div>
          );
        }
        return null;
      })}
      <div className="d-flex footer">
        {dataPoint.files && dataPoint.files.length && (
          <span title={'Has attachments'} data-testid="has-attachments"><File className="footer-icons" /></span>
        )}
      </div>
    </div>
  );
}
